import { setupForDark } from '@theme';
import classNames from 'classnames';

function TagsCircleIcon({
  size = 36,
  className = '',
  onClick = (event) => {}
}: {
  size?: number;
  className?: string;
  onClick?: (event) => void;
}) {
  return (
    <span className={className} onClick={onClick}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={size}
        viewBox='0 0 20 20'
        fill='none'
      >
        <path
          d='M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10Z'
          className={classNames(setupForDark('fill-variable-green'))}
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M15 5.90872C15 5.65768 14.7965 5.45418 14.5455 5.45418H12.2728C12.0217 5.45418 11.8182 5.65768 11.8182 5.90872C11.8182 6.15976 12.0217 6.36327 12.2728 6.36327H14.0909V14.0905H12.2728C12.0217 14.0905 11.8182 14.294 11.8182 14.5451C11.8182 14.7961 12.0217 14.9996 12.2728 14.9996H14.5455C14.7965 14.9996 15 14.7961 15 14.5451V5.90872Z'
          className={classNames(setupForDark('fill-black'))}
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M5.00004 5.90872C5.00004 5.65768 5.20354 5.45418 5.45458 5.45418H7.72731C7.97835 5.45418 8.18185 5.65768 8.18185 5.90872C8.18185 6.15976 7.97835 6.36327 7.72731 6.36327H5.90913V14.0905H7.72731C7.97835 14.0905 8.18185 14.294 8.18185 14.5451C8.18185 14.7961 7.97835 14.9996 7.72731 14.9996H5.45458C5.20354 14.9996 5.00004 14.7961 5.00004 14.5451V5.90872Z'
          className={classNames(setupForDark('fill-black'))}
        />
      </svg>
    </span>
  );
}

export default TagsCircleIcon;
